import React from 'react';
import PropTypes from 'prop-types';
import { Calendar } from '@sparefoot/react-core';
import { withProps } from 'recompose';
import classnames from 'classnames';
import { format, parse, addDays } from 'date-fns';
import { formatDatePretty } from 'utils/dateUtils';

import './CalendarV2.scss';

export const enhance = withProps(({ className }) => ({
	className: classnames(className, 'ss-calendar-v2'),
}));

const CalendarWrapper = enhance(Calendar);

export function CalendarV2({ input, closures, reservationWindow, moveInDate }) {
	let selectedDateObj = null;
	if (moveInDate) {
		selectedDateObj = parse(moveInDate);

		if (!selectedDateObj || isNaN(selectedDateObj.getTime())) {
			selectedDateObj = null;
		}
	}

	const reservationWindowDate = addDays(new Date(), reservationWindow);

	return (
		<div className="calendar-container">
			<CalendarWrapper
				closures={closures}
				reservationWindow={reservationWindowDate}
				today={new Date()}
				selectedDate={selectedDateObj}
				onDateClick={(dateObj) => {
					const actualDate = dateObj.date || dateObj;
					const formattedDate =
						dateObj.string || format(actualDate, 'MM/DD/YYYY');
					input.onChange(formattedDate);
					input.onBlur(formattedDate);
				}}
			/>
			<div className="calendar-date-text-container">
				<p className="move-in-date-label sf-type">MOVE-IN DATE</p>
				<h3
					className={`calendar-asterisk sf-type${moveInDate ? ' date-selected' : ''}`}
				>
					{moveInDate
						? formatDatePretty(moveInDate)
						: 'Select a day...'}
				</h3>
				<span className="calendar-date-text sf-type">
					If you're unsure of your move-in date, select an estimated
					date. This can be changed later.
				</span>
			</div>
		</div>
	);
}

CalendarV2.propTypes = {
	input: PropTypes.shape({
		value: PropTypes.string,
		onChange: PropTypes.func.isRequired,
		onBlur: PropTypes.func.isRequired,
	}).isRequired,
	meta: PropTypes.shape({
		touched: PropTypes.bool,
		error: PropTypes.string,
	}).isRequired,
	closures: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
	reservationWindow: PropTypes.number.isRequired,
	showSelectedDate: PropTypes.bool,
	moveInDate: PropTypes.string,
};

export default CalendarV2;
